import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { FRONTEND_ROOT } from "../../../config/constants";
import styles from "./Headline.css";

export default function Headline(_ref) {
  var headline = _ref.headline,
      permalink = _ref.permalink,
      noLink = _ref.noLink;

  if (headline && permalink && !noLink) {
    return React.createElement(
      Link,
      { to: permalink.replace(FRONTEND_ROOT, ""), className: styles.headline },
      React.createElement(
        "h3",
        null,
        headline
      )
    );
  } else if (headline) {
    return React.createElement(
      "h3",
      { className: styles.headline },
      headline
    );
  } else {
    return null;
  }
}

Headline.propTypes = {
  headline: PropTypes.string.isRequired,
  permalink: PropTypes.string,
  noLink: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/Library/Headline/Headline.js